export default "__VITE_ASSET__8b7WraXu__"